<template>
  <!-- 为了更好的体验，请使用竖屏浏览 -->
  <div id="fullscreen_tips" v-show="screenShow">
    <div class="screen">
      <img src="https://jd-asset.elloworld.cn/desirecity/img/screen_bg.jpg" alt="">
    </div>
    <div class="screen-bg"></div>
  </div>
</template>

<script>
  import Env from '../assets/js/screen'

  export default {
    name: "screen",
    data() {
      return {
        screenShow: false
      }
    },
    mounted() {
      var _this = this
      // this.flipEquipment();
      this.isMobile()
      // window.addEventListener('orientationchange', function () {
      //   _this.flipEquipment()
      // })
      this.orientInit();
      window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', function () {
        setTimeout(_this.orientInit, 200);
      }, false)
    },
    methods: {
      // flipEquipment() {
      //   if (window.orientation === 0 || window.orientation === 180) {
      //     this.screenShow = false;
      //     this.$emit('landscape', false)
      //     return false;
      //   } else if (window.orientation === 90 || window.orientation === -90) {
      //     this.screenShow = true;
      //     this.$emit('landscape', true)
      //     return false;
      //   }
      // },
      orientInit() {
        var orientChk = document.documentElement.clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';
        console.log(document.documentElement.clientWidth)
        console.log(document.documentElement.clientHeight)
        console.log(orientChk)
        if (orientChk === 'landscape') {
          this.screenShow = true
          this.$emit('landscape', true)
        } else {
          this.screenShow = false
          this.$emit('landscape', false)
        }
      },

      isMobile() {
        var equipment = new Env()
        if (equipment.isAppMobile) {
          // this.$emit('loadingShow', true)
          console.log(equipment.isAppMobile + ":移动端");
        } else {
          console.log(equipment.isAppMobile + ":网页端");
          this.screenShow = true;
          // this.$emit('loadingShow', false)
        }
      }
    }
  }
</script>

<style scoped lang="less">
  #fullscreen_tips {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-size: cover;
    background-color: #000;
    z-index: 99999999999;

    .screen {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .screen-bg {
      position: absolute;
      width: 24rem;
      height: 42rem;
      top: -5rem;
      left: 50%;
      margin-left: -12rem;
      background: url("https://jd-asset.elloworld.cn/desirecity/img/screen_icon.png") no-repeat;
      background-size: cover;
    }
  }


  /*.mod-orient-layer {*/
  /*position: absolute;*/
  /*width: 100%;*/
  /*top: 45%;*/
  /*margin-top: -75px;*/
  /*text-align: center;*/
  /*}*/

  /*.mod-orient-layer_icon {*/
  /*!*background-image: url('../assets/images/screen.png');*!*/
  /*display: inline-block;*/
  /*width: 67px;*/
  /*height: 100px;*/
  /*transform: rotate(90deg);*/
  /*-webkit-transform: rotate(90deg);*/
  /*-webkit-animation: rotation infinite 1.5s ease-in-out;*/
  /*animation: rotation infinite 1.5s ease-in-out;*/
  /*background-size: 67px;*/
  /*}*/
  @keyframes arrowAnime {
    0% {
      transform: scale(.55) translate(-5px, -5px);
    }
    50% {
      transform: scale(.50) translate(0px, 0px);
    }
    100% {
      transform: scale(.55) translate(-5px, -5px);
    }
  }

  @-webkit-keyframes rotation {
    0%,
    10% {
      -webkit-transform: rotate(0deg);
    }
    40%,
    50% {
      -webkit-transform: rotate(90deg);
    }
    90%,
    100% {
      -webkit-transform: rotate(0deg);
    }
  }

  @keyframes rotation {
    0%,
    10% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    40%,
    50% {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
    }
    90%,
    100% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }

  .mod-orient-layer_desc {
    margin-top: 20px;
    font-size: 15px;
    color: #fff;
  }

</style>
